/**
 * 垂直排列推广中介卡片
 * 
 * @Author: Focci
 * @Date: 2023-07-31 09:09:19
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-31 09:09:19
 */

'use client'

import PropTypes from 'prop-types'
import Link from 'next/link'
import AspectRatioCover from '@comp/AspectRatioCover'
import { detail } from '@lib/route/agent'
import { useLocale, useTranslations } from 'next-intl'
import { imageSize } from '@lib/image/loader'

export default function ListingPromoteAgent({
  data = {}
}) {
  const ts = useTranslations('search')
  const locale = useLocale()
  const url = detail(data?.slug, locale)
  const cover = imageSize(data?.name_card_desktop, 480, 360, 'fill', 90)
  
  return (
    <div className="rounded-md bg-white overflow-hidden h-full box-border shadow-listing">
      <Link href={url}>
        <div className="relative bg-cf0 relative p-1 aspect-[480/360]">
          <div className="absolute inset-0">
            <AspectRatioCover
              brand=""
              src={cover}
              width={480}
              height={360}
              alt={data?.name}
              className="object-contain"
            />
          </div>
        </div>
        <div className="px-2 py-4 flex justify-between">
          <div className="flex flex-col w-full">
            <div>{data?.name_card_text}</div>
            <div className="text-right w-full mt-1">
              <span className="border border-ce6 px-1 rounded-sm text-meta text-f.6">
                {ts('promote')}
              </span>
            </div>
          </div>
        </div>
      </Link>
    </div>
  )
}

ListingPromoteAgent.propTypes = {
  data: PropTypes.object,
}
